import { useMatch } from 'react-router-dom';

import { ROUTES } from '@/constants/routing';

const useMinimalLayout = () => {
  return useMatch(`${ROUTES.IFRAME}/*`);
};

export default useMinimalLayout;
